import React from 'react';
import axios from 'axios';

import FinishMessage from './finish-message';
import Form from './form';
import Error from './error';
import Process from './process';
import './style.scss';


class TrialForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      artistName: '',
      submitting: false,
      success: false,
      error: false,
      ready: false,
      cookie_id: undefined,
      data: {
        newsletter: false,
      }
    };
  }

  componentDidMount() {
    var name = "hubspotutk=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        this.setState({
          cookie_id: c.substring(name.length, c.length)
        });
      }
    }
  }

  handleSubmit = (ev) => {
    ev.preventDefault();
    const { data, cookie_id } = this.state;
    const date = new Date();
    const start = date.toISOString();
    const expires = new Date(+new Date() + 12096e5).toISOString();
    this.setState({submitting: true})
    
    const postData = {
      cookie_id,
      trial: {
        mode: this.props.type,
        expires: expires,
        notes: `Created on website on ${start} for ${this.props.type}`,
      },
      project: {
        title: data.artist_name,
        events_in: start,
      },
      mail: {
        newsletter: data.newsletter
      },
      aboss_client: {
        client_info: {
          name_first: data.name_first,
          name_last: data.name_last,
          company: data.company_name,
          email: data.email,
          website: data.website,
          phonenumber: data.phonenumber,
          findout: data.findout
        }
      },
      contact: {
        profile_attributes: {}
      },
      agency_user: {}
    }
    if (this.props.type === 'agency') {
      postData.agency_user = {
        name_first: data.name_first,
        name_last: data.name_last,
        company: data.company_name,
        email: data.email,
        city: data.city,
        postalcode: data.postalcode,
        street: data.address,
      }
    }

    if (this.props.type === 'artist') {
      postData.contact.profile_attributes = {
        name_first: data.name_first,
        name_last: data.name_last,
        company: data.company_name,
        email: data.email,
        city: data.city,
        postalcode: data.postalcode,
        street: data.address,
      }
    }
    axios.post('https://api.a-boss.net/trials', postData)
      .then(response =>  {
        this.setState({success: true});
      })
      .catch(error => {
        this.setState({error: true});
      });
  }


  setData = e => {
    let value = e.target.value;
    if (e.target.name === 'terms' || e.target.name === 'newsletter') {
      value = e.target.checked
    }
    this.setState({data: {...this.state.data, [e.target.name]: value}}, () => {
      const { name_first = '', name_last = '', artist_name = '', email = '', terms = false} = this.state.data;
      if (
        (name_first.length > 0 || name_last.length > 0) &&
        artist_name.length > 0 &&
        terms &&
        email.length > 0
      ) {
        this.setState({ready: true})
    } else {
      this.setState({ready: false})
    }
    });

    if (e.target.name === 'artist_name') {
      this.setState({artistName: e.target.value});
    }


  }

  render() {
    let submitting = '';
    let success = '';
    let ready = 'disabled';
    let termsLink = 'https://aboss.notion.site/Terms-Agency-763e476c6c6f4a4aad121f4ff81ad5e5';

    if(this.state.ready && !this.state.submitting) {
      ready = ''
    }

    if (this.state.submitting) {
      submitting = 'is-submitting';
    }

    if (this.state.success || this.state.error) {
      success = 'is-finished';
    }

    if (this.props.type === 'artist') {
      termsLink = 'https://aboss.notion.site/Terms-Artist-0e15af0b52a34db4bb8c89ba43da14fd';
    }

    return (
      <div>
        <FinishMessage artistName={this.state.artistName} success={this.state.success} error={this.state.error} email={this.state.data.email}/>
        <div className={`signup-container ${submitting} ${success}`}>
          <form onSubmit={this.handleSubmit}>
            {(!this.state.success) && (
              <div className="form-container">
                <Form setData={this.setData} />
                {(!this.state.success && !this.state.error) && this.state.submitting && <Process />}

                {(this.state.error && this.state.submitting) && <Error />}

                {(!this.state.success && !this.state.error) && (
                  <div className="form-subscription">
                    <input type="checkbox" name="terms" id="terms" onChange={this.setData} required/>
                    <label htmlFor="terms">
                      I accept the <a href={termsLink} target="_blank">terms and conditions</a>.
                    </label>
                  </div>
                )}
                {(!this.state.success && !this.state.error) && (
                  <div className="form-subscription">
                    <input type="checkbox" name="newsletter" id="newsletter" onChange={this.setData}/>
                    <label htmlFor="newsletter">I want to receive the monthly ABOSS newsletter in my mailbox.</label>
                  </div>
                )}

                <div className="form-button"><button className={ready}>Start your trial</button></div>

              </div>
            )}
          </form>
        </div>
      </div>
    );
  }
}

export default TrialForm;


// WEBPACK FOOTER //
// src/views/trial/trial-form.js